/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import useTranslation from '@src/hooks/useTranslation';
import useMediaQuery from '@src/hooks/useMediaQuery';
import { SmallCard } from '@src/components/card/learningArea';
import { SmallCardsWrapper } from '@src/components/home/components/cardStyle';
import { getLearningAreasCall } from '@src/store/actions/learningArea';
import { getLearningAreas, getLearningAreasByKey } from '@src/store/selectors/learningArea';

const PaddingWrapper = styled.div`
	@media (min-width: 768px) {
		padding: 32px 0;
	}
  @media
		(max-width: 576px),
		(min-width: 576px) {
			padding: 16px 0;
		}
  @media
		(min-width: 992px),
		(min-width: 1200px) {
			padding: 50px 0;
		}
`;

const Title = styled.div`
	font-size: 22px;
	font-weight: 500;
	padding-left: 10px;
	margin-bottom: 15px;
	border-left: 4px solid ${props => props.theme.colors.secondary};
	color: ${props => props.theme.colors.secondary};
`;

const Divider = styled.div`
  border-bottom: 1px solid #cfcfcf;
`;

const StyledSmallCardsWrapper = styled(SmallCardsWrapper)`
 	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-row-gap: 36px;
	grid-column-gap: 12px;
`;

const selectCardComponents = ({ mediaMatch }) => {
	const { isMobile } = mediaMatch;

	if (isMobile) {
		return {
			Card: SmallCard,
			CardsWrapper: StyledSmallCardsWrapper,
		};
	}

	return {
		Card: SmallCard,
		CardsWrapper: SmallCardsWrapper,
	};
};

interface LearningAreaProps {
	item: {
		chosen: boolean;
		editableList: string[];
		isPreview: boolean;
		key: string;
		name: string;
		type: string;
		sectionTitle: string;
		list?: string[];
	};
}

const LearningArea = ({ item }: LearningAreaProps): JSX.Element => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { mediaMatch } = useMediaQuery();
	const { sectionTitle, key } = item;
	let { list = [] } = item;
	list = list.filter(i => !!i);
	const area_ids = list.join(',');
	useEffect(() => {
		if (area_ids) {
			dispatch(getLearningAreasCall({ key, area_ids }));
		}
	}, []);
	let areas = [];
	if (area_ids) {
		areas = useSelector(getLearningAreasByKey(key));
	} else {
		areas = useSelector(getLearningAreas) || [];
	}

	const defaultTitle = t('training:learning:path:title');
	const { Card, CardsWrapper } = selectCardComponents({ mediaMatch });

	const handleClickCard = shortLink => {
		window.open(`/learning-area/${shortLink}`, '_blank');
	};
	if (areas.length === 0) return null;
	return (
		<PaddingWrapper>
			<Title>{sectionTitle || defaultTitle}</Title>
			<Divider />
			<CardsWrapper>
				{
					areas.map(learningArea => (
						<Card
							key={learningArea.id}
							onClick={() => handleClickCard(learningArea.short_link)}
							photos={learningArea.photos.map(photo => ({
								id: photo?.id,
								link: photo?.link,
								alt: photo?.alt_title,
							}))}
							title={learningArea.name}
							desc={learningArea.intro}
						/>
					))
				}
			</CardsWrapper>
		</PaddingWrapper>
	);
};

export default LearningArea;
